import axios from 'axios';
import Api from '../library/Api.js';
import base from './ServicoBase.js';

export default {

      getModel(){   


      	    var form = {
                              id: null , 
                              nome: "", 
                              id_finalidade: null , 
                              descricao: "", 
                              data_validade: null , 
                              status: "", 
                              cliente_oculto: null , 
      	    }

      	    return form;
      },

      getListStatusOptions(){
            /* <option value="1">Ativo</option><option value="2">Inativo</option><option value="3">Não Publicar</option>   */

             var options = [
                       {value: 1, label: "Ativo"},
                       {value: 2, label: "Inativo"},
                       {value: 3, label: "Não Publicar"}
             ];

             return options;
      },

      getById(id){

                  return Api.Call("modelo_checklist/" + id + "", "get", {});

      },

      salvar(form, fn_progress){
            
            
            if ( form.id != null && form.id != ""){
                 // var data = base.removeColumns( form, "cadastrado_por,valido,verificado,eliminado");
                  return Api.Call("modelo_checklist/" + form.id + "", "PUT", form, fn_progress );
            } else {

                  
                return Api.Call("modelo_checklist" , "POST", form, fn_progress);


            }      

      },
      delete(id){
            return Api.Call("modelo_checklist/" + id + "", "DELETE", {} );
      },
      filtrar(page, search ){

      	var data = {filtro: search , page: page, pagesize: process.env.VUE_APP_PAGESIZE}

      	return Api.Call( "modelo_checklist_grid" , "get", data );


     },
     
     getList(pdata){
         //  console.log("serialize? " + "modelo_checklist?" + base.serialize(pdata)  );
         //  console.log("data? "); console.log( pdata );

                    return Api.Call( "modelo_checklist?" + base.serialize(pdata) , "get", {} );


     },
     getListItensVazio(id_categoria){

                   return Api.Call( "itens_categoria_tomodelo?id=" + id_categoria , "get", {} );
      
     },
     getStatusNome(id, list){

                  var find = list.filter( function (item){
                        return item.id.toString() == id.toString()
                  });

                  if ( find.length > 0 )
                     return find[0].nome;

          return "";

     },

     getStatusList(){

          var list = [
                 {id: 1, nome: "Ativo"},
                 {id: 2, nome: "Inativo"},
                 {id: 3, nome: "Não Publicar"}];

           return list;

     },
	 
     getListByParent( tabela, id_pai  ){

      
        var data = {tabela: tabela,  id_pai: id_pai }

      	return Api.Call( "modelo_checklist_gridcad?" + base.serialize(data) , "get", data );


     },
	 
	 salvarGrid( hd_json, ids_delete_json, tabela, id_pai ){

        var data = {
            hd_json: hd_json,
            ids_delete_json: ids_delete_json,
            tabela: tabela,
            id_pai: id_pai
        };

        return Api.CallFormData("modelo_checklist_salvargrid" , "POST", data);
        
     }


}
